import styled from 'styled-components';

export const FeedbackContainer = styled('div')`
  .message-wrapper {
    p {
      text-align: center;
    }
  }
`;
